<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-contract"
    :title="`リモートアクセスサービス契約 約款${
      isConfirmationMode ? '確認' : '参照'
    }`"
  >
    <template v-slot:body="{ cancel, ok }">
      <!-- BODY -->
      <v-card-text class="pa-0 mt-1">
        <div
          :class="isConfirmationMode ? 'modal-body-small' : 'modal-body-large'"
        >
          <div class="xy-scroll-hide">
            <v-row>
              <v-col v-if="isLoadPdf">
                <embed
                  :src="downloadUrl"
                  type="application/pdf"
                  :class="isConfirmationMode ? 'embed-small' : 'embed-large'"
                />
              </v-col>
            </v-row>

            <v-row v-if="isConfirmationMode" class="d-flex justify-center">
              <v-checkbox
                hide-details
                v-model="accepted"
                :disabled="!isLoadPdf"
                label="上記の内容に同意します。"
              ></v-checkbox>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <v-divider class="mt-1"></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              v-if="isConfirmationMode"
              color="primary"
              :disabled="!accepted"
              variant="flat"
              @click="ok"
              >同意</v-btn
            >
            <v-btn @click="cancel" variant="outlined" color="primary">{{
              isConfirmationMode ? "キャンセル" : "戻る"
            }}</v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "SaContractTermsConfirm",
  props: {
    // 契約登録から遷移：true,設定情報から遷移：false
    isConfirmationMode: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },
  async beforeMount() {
    // 約款情報PDF取得でエラーにならないことを確認
    // 取得出来ずに「同意する」が押せてしまうこと防ぐ為に必要
    await this.$api.cpa5gSa.checkTermsPdf();
    this.isLoadPdf = true;
  },
  data() {
    return {
      accepted: false,
      isLoadPdf: false,
      downloadUrl: this.$api.cpa5gSa.downloadContractTermsPdfURL(),
    };
  },
});
</script>
<style lang="scss">
.embed-small {
  width: 100%;
  height: 65vh;
}

.embed-large {
  width: 100%;
  height: 70vh;
}

.xy-scroll-hide {
  overflow-x: hidden;
  overflow-y: hidden;
}

.modal-contract {
  width: 1200px;

  .modal-body-small {
    max-height: 73vh;
    min-height: 73vh;
    overflow: auto;
  }

  .modal-body-large {
    max-height: 70vh;
    min-height: 70vh;
    overflow: hidden;
  }
}
</style>
